<script>
export default {
  data() {
    return {
      stickyThreshold: 0,
      sticky: false,
    }
  },
  methods: {
    onScroll() {
      this.sticky = window.scrollY > this.stickyThreshold
    },
  },
  beforeMount() {
    if (window) {
      window.addEventListener('scroll', this.onScroll)
    }
  },
  // TODO: unbound event beforeDestroy
}
</script>

<style lang="scss">
.Sticky {
  @include trans;
  position: absolute;
  width: 100%;
  z-index: 40;

  &.sticky {
    position: fixed;
  }
}
</style>
